import { ActionIcon, TextInput, TextInputProps } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import AbsoluteError from '@/components/ui/AbsoluteError';
import { FieldTextStore } from '@/stores/local/shared/form/FieldTextStore';

import s from './FieldText.module.scss';

export type FieldTextProps = Omit<TextInputProps, 'value' | 'onChange' | 'disabled' | 'error' | 'withAsterisk'> & {
  store: FieldTextStore;
  onClear?: () => void;
  withClear?: boolean;
  inputClassName?: string;
};

const FieldText: React.FC<FieldTextProps> = ({
  store,
  withClear = false,
  rightSection,
  onClear,
  inputClassName,
  ...props
}) => {
  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      store.setValue(e.target.value);
    },
    [store],
  );

  const handleClear = React.useCallback(() => {
    if (withClear) {
      if (onClear) {
        onClear();
      }

      store.setValue('');
    }
  }, [onClear, store, withClear]);

  return (
    <TextInput
      className={s.root}
      onFocus={store.focus}
      onBlur={store.blur}
      size="sm"
      error={store.hasError && <AbsoluteError className={s.root__error} error={store.error} />}
      value={store.value ?? ''}
      onChange={onChange}
      disabled={store.disabled}
      classNames={{ input: inputClassName }}
      rightSection={
        withClear && store.value ? (
          <ActionIcon variant="transparent" color="grey" onClick={handleClear}>
            <IconX size={16} />
          </ActionIcon>
        ) : (
          rightSection
        )
      }
      {...props}
    />
  );
};

export default observer(FieldText);
